import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Form, Input, Button, Checkbox, Card, Alert, message } from "antd";

import validators from "../../validators/validators";
import { FormInputField } from "../FormInputField/FormInputField";

import * as userActions from "../../actionCreators/User";

import "./LoginForm.css";

const UpdatePasswordForm = ({
  updatePassword,
  logOut,
  error,
  buttonLoading,
  history,
  success,
  passwordError,
}) => {
  const [validationError, setValidationError] = useState({});
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const validatedClassName = "update-password-checkbox-checked";
  const inValidatedClassName = "update-password-checkbox-unchecked";

  React.useEffect(() => {
    if (success && !buttonLoading) {
      message.success("Password Updated. Login with new password");
    }
    if (!success && passwordError) {
      message.error(passwordError || error);
    }
  }, [success, buttonLoading, error]);

  const handleSubmitForm = async (values, actions) => {
    updatePassword({
      newPassword: password,
      logout_all_devices: true
    });
  };


  const onPasswordChanged = (e) => {
    let pass = e.target.value;
    setPassword(pass);
    setValidationError({
      isMinimumLimitMet: pass.length >= 8,
      isOneLowerCharacterLimitMet: /[a-z]/.test(pass),
      isOneUpperCharacterLimitMet: /[A-Z]/.test(pass),
      isOneSpecialCharacterLimitMet:
        /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(pass),
      isOneNumberLimitMet: /[0-9]/.test(pass),
      doesPasswordMatch: pass === confirmPassword && confirmPassword !== "",
    });
  };
  const onConfirmPasswordChanged = (e) => {
    let pass = e.target.value;
    setConfirmPassword(pass);
    setValidationError({
      ...validationError,
      doesPasswordMatch: pass === password && password !== "",
    });
  };
  let enableSubmitButton = true;
  try {
    Object.keys(validationError).forEach(function (key) {
      if (!validationError[key]) {
        enableSubmitButton = false;
        throw "valiation not met";
      }
    });
  } catch (e) {}
  return (
    <Card className={"LoginFormCard"}>
      <p
        style={{
          fontWeight: "bold",
          fontSize: "20px",
          textAlign: "left",
          marginBottom: "30px",
        }}
      >
        Set New Password
      </p>
      <div style={{ textAlign: "left", color: "#0000008a" }}>
        Please set your new password according to the mentioned criteria
      </div>
      <Formik
        initialValues={{ password: "", confirm_password: "" }}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => handleSubmitForm(values, actions)}
        render={(formikProps) => {
          const { errors, isSubmitting, handleSubmit } = formikProps;

          return (
            <>
              <Form onFinish={handleSubmit}>
                <Field
                  InputType={Input.Password}
                  component={FormInputField}
                  name="password"
                  labelText="Password"
                  className="text-field"
                  type="password"
                  onChange={onPasswordChanged}
                  hideErrorMessage={true}
                />
                <Field
                  InputType={Input.Password}
                  component={FormInputField}
                  name="confirm_password"
                  labelText="Confirm Password"
                  className="text-field"
                  type="password"
                  onChange={onConfirmPasswordChanged}
                  hideErrorMessage={true}
                />
                {error && <span style={{ color: "red" }}>{error}</span>}
                <ul className="password-update-indicators">
                  <li>
                    {" "}
                    <Checkbox
                      className={
                        validationError?.isMinimumLimitMet
                          ? validatedClassName
                          : inValidatedClassName
                      }
                      checked={true}
                    >
                      Must have at least 8 characters
                    </Checkbox>
                  </li>
                  <li>
                    {" "}
                    <Checkbox
                      className={
                        validationError?.isOneUpperCharacterLimitMet
                          ? validatedClassName
                          : inValidatedClassName
                      }
                      checked={true}
                    >
                      Must have at least 1 uppercase letter
                    </Checkbox>
                  </li>
                  <li>
                    {" "}
                    <Checkbox
                      className={
                        validationError?.isOneLowerCharacterLimitMet
                          ? validatedClassName
                          : inValidatedClassName
                      }
                      checked={true}
                    >
                      Must have at least 1 lowercase letter
                    </Checkbox>
                  </li>
                  <li>
                    {" "}
                    <Checkbox
                      className={
                        validationError?.isOneSpecialCharacterLimitMet
                          ? validatedClassName
                          : inValidatedClassName
                      }
                      checked={true}
                    >
                      Must have at least 1 special character
                    </Checkbox>
                  </li>
                  <li>
                    {" "}
                    <Checkbox
                      className={
                        validationError?.isOneNumberLimitMet
                          ? validatedClassName
                          : inValidatedClassName
                      }
                      checked={true}
                    >
                      Must have at least 1 number
                    </Checkbox>
                  </li>
                  <li>
                    {" "}
                    <Checkbox
                      className={
                        validationError?.doesPasswordMatch
                          ? validatedClassName
                          : inValidatedClassName
                      }
                      checked={true}
                    >
                      Password and Confirm Password must be same
                    </Checkbox>
                  </li>
                </ul>
                <Form.Item className="login-button-section">
                  <Button
                    disabled={!enableSubmitButton}
                    type="primary"
                    htmlType="submit"
                    loading={buttonLoading}
                    className={"loginFormButton"}
                  >
                    RESET PASSWORD
                  </Button>
                  <div style={{ textAlign: "center", margin: "1%" }}></div>
                </Form.Item>
              </Form>
            </>
          );
        }}
      />
    </Card>
  );
};

const mapStateToProps = ({
  user: {
    currentUser: { error, buttonLoading, success, passwordError },
  },
}) => ({ error, buttonLoading, success, passwordError });

const mapDispatchToProps = (dispatch) => ({
  updatePassword: bindActionCreators(userActions.updatePassword, dispatch),
  logOut: bindActionCreators(userActions.logOut, dispatch),
});

UpdatePasswordForm.propTypes = {
  user: PropTypes.object,
  updatePassword: PropTypes.func.isRequired,
  logOut: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      redirectUrl: PropTypes.string,
      search: PropTypes.string,
    }),
  }),
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePasswordForm);
